 <template>

   <div v-role="roles">
        <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  <v-data-table
    :headers="headers"
    :items="this.dados_cadeirantes"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>

      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Lista de Cadeirantes

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
        <v-btn  v-if="search"  @click="initprofdisc(search)" text icon color="green">
              <v-icon>cached</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="800px">
          <!--<template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>

            <v-card-text>
              <p>Funcionalidade indisponivel de momento.</p>~
              <p>Resolveremos o mais breve possivel.</p>
            </v-card-text>

          </v-card>
        </v-dialog>

        <v-dialog   max-width="800px">
          <!--<template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>

            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col cols="12" sm="12" md="12">

                     <v-combobox  id="turma"
                          v-model="editedItem.turma"
                          item-value="pkturma"
                          item-text="turmadescricao"
                          :items="turmasFiltered"
                          chips
                          label="Turma"
                      ></v-combobox>
                    </v-col>

                      <v-col cols="12" sm="12" md="6">

                     <v-text-field v-if="false" id="disciplina"
                          v-model="editedItem.iddisciplina"
                          item-value="iddisciplina"

                      ></v-text-field>
                    </v-col>

                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
            <template v-if="progresso">
               <div class="text-center">
                  <v-progress-circular
                    :size="50"
                    color="blue"
                    indeterminate
                  ></v-progress-circular>
               </div>
            </template>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn v-if="!replace"
                color="blue darken-1"
                :disabled="
                  btn_status
                "
                text
                @click="save"
                >Save</v-btn
              >

            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-icon v-if="item.cadeiraStatus === 'Não Inscrito'"  size="20" color="green" dark @click="editItem(item)">edit</v-icon>
    </template>
    <template v-slot:item.cadeiraNota="{ item }">
        <span v-if="showEdit && pautaReferida !== item.idpauta" >{{item.cadeiraNota}}</span>
         <v-text-field
         v-model="notaCadeira"
         :rules="notaRules"
         v-if="!showEdit && pautaReferida === item.idpauta"
            label="Nota"
            style="width:50px;"
          ></v-text-field>
    </template>
    <template v-slot:item.action="{ item }">
        <v-btn
        color="primary"
        v-if="showEdit && pautaReferida !== item.idpauta"
        fab
        x-small
        dark
        class="mr-2"
        @click="bt_edit(item)"
      >
        <v-icon>edit</v-icon>
      </v-btn>
      <v-btn
        color="primary"
        v-if="!showEdit && pautaReferida === item.idpauta"
        fab
        x-small
        dark
        class="mr-2"
        @click="bt_save(item)"
      >
        <v-icon>save_alt</v-icon>
      </v-btn>
    </template>
    <template v-slot:item.cadeiraStatus="{ item }">
        <span v-if="item.cadeiraStatus === 'Inscrito'" style="color:green" >{{item.cadeiraStatus}}</span>
        <span v-if="item.cadeiraStatus === 'Não Inscrito'" style="color:red" >{{item.cadeiraStatus}}</span>
    </template>
    <template v-slot:no-data>
      Sem dados
    </template>
  </v-data-table>
   </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    roles: 'func',
    replace: false,
    disciplinas: [],
    notaCadeira: null,
    disciplinasFiltered: [],
    pautaReferida: null,
    text: '',
    flag_curso: '',
    formValid: true,
    isLoading: true,
    progresso: false,
    showEdit: true,
    overlay: false,
    turmasAll: [],
    turmasFiltered: [],
    dados_cadeirantes: [],
    search: '',
    cursos: [],
    btn_status: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'inválido',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Código de Matricula', value: 'matricula' },
      { text: 'Disciplinas', value: 'cadeiras' },
      { text: 'Classe', value: 'classe' },
      { text: 'Ano Lectivo', value: 'anoLectivo' },
      { text: 'Nota Recurso', value: 'mfd' },
      { text: 'Nota da Cadeira', value: 'cadeiraNota' },
      { text: 'Action', value: 'action' }
    ],

    editedIndex: -1,

    editedItem: {
      idProfessorDisciTurma: 0,
      curso: null,
      idpauta: 0,
      idturma: 0,
      disciplina: '',
      cadeiraStatus: '',
      iddisciplina: 0,
      professor: 0,
      turma: null,
      desciplinaDescricao: '',
      pkpauta: 0,
      matricula: '',
      turmaDescricao: '',
      mfd: '',
      idcadeiradefault: 0,
      cadeiraAnoqueFez: '',
      anoLectivo: '',
      autor: '',
      nome: ''

    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''
    }
  }),

  computed: {
    formTitle () {
      return 'Inscrição na Cadeira em atraso'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dados_cadeirantes () {
      this.isLoading = false
      this.$store.state.isLoading = false
    }
  },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // this.initializeCursos()
    // this.initializeturmasAll()
    this.ListarCadeirantes()
  },

  methods: {

    async ListarCadeirantes () {
      this.dados_cadeirantes = []
      this.overlay = true
      try {
        this.dados_cadeirantes = await axios.get('/cadeira')
          .then(res => res.data)

        this.overlay = false
      } catch (erro) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    bt_edit (item) {
      this.showEdit = false
      this.pautaReferida = item.idpauta
      this.notaCadeira = item.cadeiraNota
    },
    async bt_save (item) {
      this.showEdit = true
      item.cadeiraNota = ''
      this.pautaReferida = null
      let params = {
        nota: this.notaCadeira,
        pkPauta: item.pkpauta
      }
      try {
        let msg = await axios.post('/LancarNotaCadeira', params)
          .then(res => res.data)
        this.overlay = false
        if (msg.affectedRows >= 1) {
          item.cadeiraNota = this.notaCadeira
          this.text = 'Nota gravada com sucesso'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgSucess',
            timeout: 3000
          })
          if (item.notaCadeira >= 0) {
            let index = this.dados_cadeirantes.indexOf(item)
            this.dados_cadeirantes.splice(index, 1)
          }
        } else {
          this.text = 'Ocorreu um erro'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 3000
          })
        }
      } catch (erro) {
        this.overlay = false

        this.text = 'error'
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    }
  }
}
</script>
